import React from "react";
import { FeedbackComponent } from "../../../../components/feedback/feedback.component";
import { useTranslation } from "react-i18next";
import { SvgAssets } from "../../../../components/icon/assets";
import Icon from "../../../../components/icon/icon";
import i18next from "i18next";

export const LinkExpiredScreen: React.FC = () => {
  const { t } = useTranslation();
  const appLang = sessionStorage.getItem("infoFormLang") || "en";
  i18next.changeLanguage(appLang);

  return (
    <div className="h-screen w-screen flex flex-col">
      <FeedbackComponent
        title={t("link_expired")}
        icon={<Icon svg={SvgAssets.expired} width={141} height={127} />}
        description={t("link_expired_desc")}
      />
    </div>
  );
};
